import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface BepsRollforwardResponse {
  callSuccess: string;
  errorMessage?: string;
  [key: string]: unknown;
}

@Injectable({ providedIn: 'root' })
export class BepsRollforwardService {
  constructor(private http: HttpClient) {}

  rollforwardCbcrData(
    baseUrl: string,
    ssoId: string,
    taxYear: string
  ): Observable<BepsRollforwardResponse> {
    const url = `${baseUrl}/saveJsonObject?action_code=8gn2g1`;
    let params = new HttpParams();
    if (ssoId) {
      params = params.set('sso_id', ssoId);
    }
    if (taxYear) {
      params = params.set('tax_year', taxYear);
    }

    return this.http.post<BepsRollforwardResponse>(url, params.toString(), {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
      withCredentials: true,
    });
  }
}
